
export function toISODate () {
  // Возвращает текущую дату в формате ISO
  var today = new Date(Date.now())
  return today.toISOString().slice(0, 10)
}

export function getTreeView (listRoute, groups, path = '') {
  return listRoute.reduce(function (routes, route) {
    if (route.children && Array.isArray(route.children)) {
      let path0 = path + '/' + route.path
      path0 = path0.replace('//', '/')
      if (('meta' in route) && ((('groups_menu' in route.meta) && groups.filter(group => route.meta.groups_menu.includes(group)).length > 0) || ('isAuthenticated' in route.meta && route.meta.isAuthenticated))) {
        routes.push({
          id: path0,
          path: path0,
          title: route.meta.title,
          icon: route.meta.icon,
          href: ('href' in route.meta ? route.meta.href : null),
          target: ('target' in route.meta ? route.meta.target : '_self'),
          children: getTreeView(route.children, groups, path0)
        })
      }
      // else {
      //     routes.push({ id: path0, path: path0, name: a.name, is_visible: false, children: getAll(a.children, groups, path0) })
      //   }
    } else {
      let path0 = path + '/' + route.path
      path0 = path0.replace('//', '/')
      if (('meta' in route) && ((('groups_menu' in route.meta) && groups.filter(group => route.meta.groups_menu.includes(group)).length > 0) || ('isAuthenticated' in route.meta && route.meta.isAuthenticated))) {
        routes.push({
          id: path0,
          path: path0,
          title: route.meta.title,
          icon: route.meta.icon,
          href: ('href' in route.meta ? route.meta.href : null),
          target: ('target' in route.meta ? route.meta.target : '_self')
        })
      }
    }
    return routes
  }, [])
}
